import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        consistentPadding: {
            padding: '0 15px 0 15px'
        },
    }),
);

export default useStyles;